var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFamily128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.316 63.3188C47.1642 63.3188 53.5265 56.9565 53.5265 49.1082C53.5265 41.26 47.1642 34.8977 39.316 34.8977C31.4677 34.8977 25.1055 41.26 25.1055 49.1082C25.1055 56.9565 31.4677 63.3188 39.316 63.3188Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3158 63.3186C51.0882 63.3186 60.6316 73.9224 60.6316 87.0028V110.687H20.3684C19.0604 110.687 18 109.627 18 108.319V87.0028C18 73.9224 27.5434 63.3186 39.3158 63.3186Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3153 51.4765C93.4716 51.4765 100.894 44.0539 100.894 34.8976C100.894 25.7413 93.4716 18.3186 84.3153 18.3186C75.159 18.3186 67.7363 25.7413 67.7363 34.8976C67.7363 44.0539 75.159 51.4765 84.3153 51.4765Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.316 51.4763C97.3965 51.4763 108 64.731 108 81.0816V108.318C108 109.626 106.94 110.687 105.632 110.687H60.6318V81.0816C60.6318 64.731 71.2356 51.4763 84.316 51.4763Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFamily128);
export default __webpack_public_path__ + "static/media/pictogramBeaconFamily128.c5a9b853ad36a1e4ea66d206c3bcc38f.svg";
export { ForwardRef as ReactComponent };